/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import { LicenseType } from '../model/license-type';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class LicenseTypeService {


  private readonly licenseTypeUrl: string;

  constructor(private http: HttpClient) {
    this.licenseTypeUrl = inject(APP_CONFIG).baseUrl + '/api/licensetypes';
  }


  getAll(): Observable<LicenseType[]> {
    const url = `${this.licenseTypeUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(licenseTypes => licenseTypes as LicenseType[]));
  }

  addNew(licenseType: LicenseType): Observable<LicenseType> {
    const url = `${this.licenseTypeUrl}`;
    return this.http.post(url, licenseType, httpOptions).pipe(
      map( licenseType => licenseType as LicenseType ));
  }

  update(licenseType: LicenseType): Observable<LicenseType> {
    var url = `${this.licenseTypeUrl}/${licenseType.licenseTypeId}`;
    return this.http.put(url, licenseType, httpOptions).pipe(
      map( licenseType => licenseType as LicenseType ));
  }

}
